import React,{useState,useEffect} from 'react'
import { motion,AnimatePresence  } from 'framer-motion'
import { ChevronDown, ChevronUp } from 'lucide-react'
import background from '../../assets/images/background.jpg'
import antpc1 from '../../assets/images/Ant_Esports_Vanguard1.png'
import {Link} from 'react-router-dom'
const products = [
 
];
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
}
const tableData = [
    {
        type: "PC",
        model: "MP-7-G3",
        gpu: "1 x A2000 (16GB) / 64GB DRAM",
        cache: "320GB Cache",
        traditional: "8 x A2000",
        },
        {
          type: "PC",
          model: "MP-13-G3",
          gpu: " 1 x A2000 (16GB) / 128GB DRAM",
          cache: "640GB Cache",
          traditional: "16 x A2000",
          },
          {
            type: "PC",
            model: " MP-34-G3",
            gpu: "2 x A2000 (32GB)/ 128GB DRAM",
            cache: "320GB Cache",
            traditional: "26 x A4000",
            },
            {
              type: "WS",
              model: "MW-70-G4",
              gpu: "2 x A4000 (40GB)/ 256GB DRAM",
              cache: "1.2TB Cache",
              traditional: "57 x A4000",
              },
              {
                type: "WS",
                model: "MW-90-G4",
                gpu: "4 x A4000 (80GB)/ 512GB DRAM",
                cache: "2TB Cache",
                traditional: "83 x A4000",
                },
                {
                  type: "SRV",
                  model: "MS-100-NA-G5",
                  gpu: "2 x A6000 (96GB)/ 1TB DRAM",
                  cache: "2TB Cache",
                  traditional: "40 x A6000",
                  },
                  {
                    type: "SRV",
                    model: "MS-180-NA-G5",
                    gpu: "4 x A6000 (198GB)/ 2TB DRAM",
                    cache: "4TB Cache",
                    traditional: "75 x A6000",
                    },
    {
        type: "SRV",
        model: "MS-405-NA-G5",
        gpu: "8 x A6000 (384GB)/ 4TB DRAM",
        cache: "8TB Cache",
        traditional: "145 x A6000",
    },
    {
      type: "SRV",
      model: "MS-685-NH1-G5",
      gpu: "8 x H100 (640GB)/ 4TB DRAM",
      cache: "16TB Cache",
      traditional: "175 x H100 ",
  },
  {
    type: "SRV",
    model: "MS-685-NH2-G5",
    gpu: "8 x H200 (1.2TB)/ 4TB DRAM",
    cache: "16TB Cache",
    traditional: "90 x H200",
},

  ]
const slideIn = (direction) => ({
  hidden: { opacity: 0, x: direction === 'left' ? -60 : 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8
    }
  }
})

// Group data by type
const groupedData = tableData.reduce((acc, item) => {
    if (!acc[item.type]) {
      acc[item.type] = []
    }
    acc[item.type].push(item)
    return acc
  }, {})

 
  
  const expandSection = {
    hidden: { height: 0, opacity: 0 },
    visible: { 
      height: "auto",
      opacity: 1,
      transition: {
        height: {
          duration: 0.4
        },
        opacity: {
          duration: 0.3,
          delay: 0.1
        }
      }
    }
  }
    
  const ProductCard = ({ product, index }) => {
    const { name, specs, image, isImageLeft, description } = product
  
    return (
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="my-20"
      >
        <div className={`max-w-7xl mx-auto grid md:grid-cols-2 gap-8 items-center px-4 ${
          isImageLeft ? '' : 'md:grid-flow-row-dense'
        }`}>
          {/* Image Section */}
          <motion.div
            variants={slideIn(isImageLeft ? 'left' : 'right')}
            className={`relative group ${isImageLeft ? 'md:order-1' : 'md:order-2'}`}
          >
            <div className="absolute -inset-1 bg-gradient-to-r from-gray/30 to-gray/30 rounded-lg blur-xl opacity-75 group-hover:opacity-100 transition duration-1000"></div>
            <div className="relative aspect-[3/4] overflow-hidden rounded-lg bg-black/50 backdrop-blur-sm border border-gray-800/50">
              <img
                src={image}
                alt={name}
                className="w-full h-full object-contain p-4 transform group-hover:scale-105 transition duration-700"
              />
            </div>
          </motion.div>
  
          {/* Content Section */}
          <motion.div
            variants={fadeInUp}
            className={`space-y-6 ${isImageLeft ? 'md:order-2' : 'md:order-1'}`}
          >
            <div className="relative p-8 rounded-2xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-black-900/90 to-black/90 backdrop-blur-xl rounded-2xl"></div>
              <div className="relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
                  {name}
                </h2>
                
                {/* Description Section */}
                <div className="mb-8 text-gray-300 leading-relaxed">
                  {description}
                </div>
                
                {/* Specs Section */}
                <div className="border-t border-gray-800 pt-6 mt-6">
                  <h3 className="text-lg font-semibold text-white mb-4">Technical Specifications</h3>
                  <ul className="space-y-3 mb-8">
                    {specs.map((spec, i) => (
                      <motion.li
                        key={i}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1 }}
                        className="text-gray-300 flex items-center space-x-2"
                      >
                        <span className="w-2 h-2 bg-emerald-600 rounded-full"></span>
                        <span>{spec}</span>
                      </motion.li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    )
  }
const ProductListing = () => {
    const [expandedSections, setExpandedSections] = useState({})
    const [isVisible, setIsVisible] = useState(false)
  
    useEffect(() => {
      setIsVisible(true)
      // Initially expand the first section
      const firstType = Object.keys(groupedData)[0]
      setExpandedSections({ [firstType]: true })
    }, [])
  
    const toggleSection = (type) => {
      setExpandedSections(prev => ({
        ...prev,
        [type]: !prev[type]
      }))
    }
  return (
    
    <div className="min-h-screen bg-black py-16 pt-5">
       {/* Hero Section */}
       <motion.section 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="relative  h-screen lg:h-screen 2xl:h-[60vh]  flex items-center justify-center"
        >
          <div 
            className="absolute inset-0 z-0 bg-gradient-to-b from-black/40 to-black"
            style={{
              backgroundImage: `url(${background})`, 
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'brightness(0.3)'
            }}
          />
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.h1 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-5xl md:text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-600 h-[90px]"
            >
              Appliances
            </motion.h1>
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-lg md:text-xl text-gray-300"
            >
              High-tech solutions engineered to enhance performance, streamline operations, and simplify everyday tasks.
            </motion.p>
          </div>
        </motion.section>


      {/* Product Listings */}
      <div className="space-y-20">
        {products.map((product, index) => (
          <ProductCard key={product.id} product={product} index={index} />
        ))}
      </div>

      <div className="min-h-screen bg-black py-16 px-4">
      <div className="max-w-[90rem] mx-auto">
        <motion.div 
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
          className="relative overflow-hidden rounded-xl"
        >
          {/* Glassmorphism backdrop */}
          <div className="absolute inset-0 bg-white/5 backdrop-blur-xl rounded-xl border border-gray-700/30"></div>
          
          <div className="relative z-10">
            <table className="w-full">
              <thead>
                <motion.tr 
                  variants={fadeInUp}
                  className=""
                >
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-200">Type</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-200">Model</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-200">GPU (VRAM) / DRAM</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-200">aiDAPTIV+</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-200">GPU / Traditional </th>
                  
                </motion.tr>
              </thead>
            </table>

            {Object.entries(groupedData).map(([type, items], groupIndex) => (
              <div key={type} className="border-b border-gray-700/30 last:border-b-0">
                <motion.button
                  onClick={() => toggleSection(type)}
                  className="w-full px-6 py-4 flex items-center justify-between bg-gradient-to-r from-gray-800/30 to-gray-700/30 hover:from-gray-800/40 hover:to-gray-700/40 transition-all duration-200"
                  whileHover={{ scale: 1.002 }}
                  whileTap={{ scale: 0.998 }}
                >
                  <span className="text-lg font-semibold text-white">{type}</span>
                  <motion.div
                    animate={{ rotate: expandedSections[type] ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ChevronDown className="w-5 h-5 text-gray-400" />
                  </motion.div>
                </motion.button>

                <AnimatePresence>
                  {expandedSections[type] && (
                    <motion.div
                      variants={expandSection}
                      initial="hidden"
                      animate="visible"
                      exit="hidden"
                      className="overflow-hidden"
                    >
                      <table className="w-full">
                        <tbody className="divide-y divide-gray-700/30">
                          {items.map((row, index) => (
                            <motion.tr
                              key={row.model}
                              variants={fadeInUp}
                              custom={index}
                              className="group hover:bg-white/5 transition-colors duration-200"
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: index * 0.1 }}
                            >
                              <td className="px-6 py-4">
                                <div className="text-gray-300 group-hover:text-white transition-colors duration-200">
                                  {row.type}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="text-gray-300 group-hover:text-white transition-colors duration-200">
                                  {row.model}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="text-gray-300 group-hover:text-white transition-colors duration-200">
                                  {row.gpu}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="text-gray-300 group-hover:text-white transition-colors duration-200">
                                  {row.cache}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="text-gray-300 group-hover:text-white transition-colors duration-200">
                                  {row.traditional}
                                </div>
                              </td>
                              
                            </motion.tr>
                          ))}
                        </tbody>
                      </table>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>

          {/* Gradient overlay for glass effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-blue-500/5 pointer-events-none"></div>
        </motion.div>
      </div>
    </div>
    </div>
  )
}

export default ProductListing

